import React, { useState } from 'react';
import { useLocale } from '../../../localization/LocaleProvider';

const RolfingTemplatePreviewPages = ({ values, display }) => {
    const [showAssessment, setShowAssessment] = useState(true);
    const [sliderValue, setSliderValue] = useState(1);
    const { translate } = useLocale();

    if(display == -1) {
      return (
        <>
          <p style={{fontWeight: "bold", fontSize: "13.5px", lineHeight: "22.5px", margin: 0, marginBottom: "5px"}}>{translate("Select Rolfing template")}</p>
          <input type="text" className="formControl" value={values.name || ""} style={{borderRadius: "15px", fontSize: "15px", fontWeight: "bold", color: "rgb(102, 102, 102)", marginBottom: "15px"}} disabled />
          <p style={{fontWeight: "bold", fontSize: "13.5px", lineHeight: "22.5px", margin: 0, marginBottom: "5px"}}>{translate("Description")}</p>
          <p style={{fontSize: "15px", lineHeight: "22.5px", margin: 0, marginBottom: "20px"}}>{values.description || ""}</p>
        </>
      )
    }

    if(display == values.properties.length) { //Slutskärm
      return (
        <>
          <p style={{fontWeight: "bold", fontSize: "13.5px", lineHeight: "22.5px", margin: 0, marginBottom: "5px"}}>Feedback</p>
          <div style={{width: "100%", marginBottom: "12px"}}>
            <textarea rows={4} style={{borderRadius: "6px", height: "70px", color: "#000000", backgroundColor: "#ebebeb", paddingRight: "16px", width: "100%", marginRight: "16px"}} placeholder={values.feedbackDescription || ""}></textarea>
          </div>
        </>
      );
    }

      return values.properties.sort((a,b) => {
        if(a.sortOrder > b.sortOrder) return 1;
        if(a.sortOrder < b.sortOrder) return -1;
        if(a.sortOrder == b.sortOrder) return 0;
      }).map((property, index) => {
      return (
        <>
          <p style={{fontWeight: "bold", fontSize: "15px", lineHeight: "22.5px", margin: 0}}>{property.name}</p>
          <p style={{fontSize: "15px", lineHeight: "22.5px", margin: 0, marginBottom: "15px", whiteSpace: "pre-wrap" }}>{property.description}</p>
          <div className="spaceBetween">
            <p style={{fontWeight: "bold", fontSize: "13.5px", lineHeight: "20.25px", margin: 0, marginBottom: "5px"}}>{translate("Assessment")}</p>
            <div style={{justifyContent: "center"}}>
              <span style={{marginRight: 6, fontSize: "12.75px", color: "rgb(136,136,136)"}}>{translate("Do not use")}</span>
            <label className="switch">
              <input type="checkbox" onChange={() => setShowAssessment(!showAssessment)}/>
              <span className="slider round"></span>
            </label>
            </div>
          </div>
          {showAssessment ? values.rolfingScale == 2 ?
          <>
            <div className="flex" style={{justifyContent: "space-around", gap: "1px", textAlign: "center", marginBottom: "7.5px"}}>
              {values.scaleLabels.map((label, index) => {
                return (
                  <div key={index} style={{flex: 1, backgroundColor: "#eaeaea", border: "1px solid #0000001a"}}>
                    <span style={{fontSize: "12.75px"}}>{label.title}</span>
                  </div>
                )
              })}

            </div>
            <input type="range" value={sliderValue} min={1} max={10} step={0.09} style={{width: "100%", padding: 0, appearance: "none", background: "rgba(102, 102, 102, 0.1)"}} onChange={(e) => setSliderValue(e.target.value)} disabled>
              
            </input>
            </>
            : 
            <div style={{display: "flex", flexDirection: "row", maxWidth: "360px", justifyContent: "space-between"}}>
              {
                [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item, index) => {
                  return (
                    <div key={index} style={{backgroundColor: "rgb(234, 234, 234)", width: "30px", height: "30px", borderRadius: "24px", textAlign: "center", paddingTop: 4}}>
                      <span style={{fontSize: "12px", color: "rgb(102,102,102)"}}>{item}</span>
                    </div>
                  )
                })
              }
            </div>
            : null
          }          
          <p style={{fontWeight: "bold", fontSize: "13.5px", lineHeight: "20.25px", margin: 0, marginTop: "15px", marginBottom: "5px"}}>{translate("Comment")}</p>
          <textarea rows={5} className="formControl" style={{borderRadius: "15px", maxHeight: "90px", color: "rgb(102, 102, 102)", resize: "none"}}></textarea>
        </>
      )
    }).filter((item, index) => index == display);
  }
  

  export default RolfingTemplatePreviewPages;